import React, { useEffect, useState } from "react";
import { api, absUrl } from "../../lib/api";
import { Section, Eyebrow, FadeIn } from "../../components/public/Section";
import { PageHero } from "./About";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => { api.get("/public/gallery").then(r => setItems(r.data)); }, []);
  const cats = ["all", ...Array.from(new Set(items.map(i => i.category).filter(Boolean)))];
  const filtered = active === "all" ? items : items.filter(i => i.category === active);

  return (
    <>
      <PageHero title="Gallery" subtitle="A visual journal of mandaps, plating and ambient design." image="https://images.unsplash.com/photo-1696940823960-ee5242bddc47?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <Eyebrow>Recent celebrations</Eyebrow>
        <div className="flex gap-2 flex-wrap mb-10">
          {cats.map(c => (
            <button key={c} onClick={() => setActive(c)} className={`px-5 py-2 text-xs tracking-[0.2em] uppercase border transition ${active === c ? "bg-navy-900 text-gold border-navy-900" : "border-navy-900/20 hover:border-gold"}`} data-testid={`gallery-filter-${c}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-3">
          {filtered.map((g, i) => (
            <FadeIn key={g.id} delay={(i % 6) * 0.05}>
              <div className="mb-3 overflow-hidden group break-inside-avoid" data-testid={`gallery-tile-${i}`}>
                <img src={absUrl(g.image_url)} alt={g.title} className="w-full transition-transform duration-700 group-hover:scale-110" />
              </div>
            </FadeIn>
          ))}
        </div>
      </Section>
    </>
  );
}
